module.exports = __webpack_public_path__ + "img/t5-salmon.4564e585.png";